export class SosInverso {
  idProposta: number;
  idMotivo: number;
  observacao: string;
}
